<template>
  <div class="nav-box">
    <ul>
       <li
        v-for="(item,idx) in navList"
        :key="item.title"
        :class="{
          'bgc-actived': currentIdx == idx,
        }"
        @click="clickToggleScene(item, idx)"
        >
            <div class="border-box">
                <div >
                    <i :class="['iconfont', item.icon]"></i>
                    <span class="text">{{ item.title }}</span>  
                </div>
                <div :class="{'border-actived':currentIdx == idx}"></div>
            </div>
        </li>
    </ul>
    <Pano/>
  </div>
  
</template>

<script>
import Pano from '@/components/Pano.vue'
import AddHotSpot from './AddHotSpot.vue'
export default {
    name:'NavBar',
    components:{
        Pano,
        AddHotSpot
    },
    data(){
        return {
            navList:[
                {title:'区域沙盘', name:'scene_quanjintu', icon:'icon-quyu'},
                {title:'项目沙盘', name:'scene_quanjintu2', icon:'icon-loudongguanli'},
            ],
            currentIdx:0,
            isRegion:false
        }
    },
    mounted(){
        this.isRegion = true
    },
    methods:{
            /**
     * 点击切换场景
     */
    clickToggleScene(item, idx) {
        this.currentIdx = idx
        this.$EventBus.$emit('globalEvent',{
        peak_to_scene: item.name
        }) 
        if(item.title === '区域沙盘') {
            this.isRegion = true
        } else{
            this.isRegion = false
        }
   
    
        // if(item.title === '项目沙盘') {
        //     this.$EventBus.$emit('gotoHotspot',{
        //     type: item
        //     }) 
        // }

    },
    }


}
</script>

<style lang="scss" scoped>
@import '@/assets/css/font_chooseList/iconfont.css';
.nav-box {
    width: 100vw;
    height: 100vh;
    ul {
        position: absolute;
        top: 1rem;
        left: 50%;
        z-index: 100;
        transform: translateX(-50%);
        display: flex;
        li {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 6rem; 
            height: 2.2rem;
            background-color: rgba(0,0,0,0.5);
            box-sizing: border-box;
            color:#fff;
            font-size: 12px;
            border-radius: 2.5rem 0 0 2.5rem;
            cursor: pointer;
            .border-box {
                position: relative;
            .text {
                margin-left: 0.3rem;
            }
            .border-actived {
                position: absolute;
                width:100%;
                height: 0.15rem;
                background:linear-gradient(244deg,rgba(255,255,255,0) 0%,orange 50%,rgba(255,255,255,0) 100%);      
                }
            }

        }

        .bgc-actived {       
          background-color: rgba(0,0,0,0.7); 
        }

        li:last-child{
          border-radius: 0 2.5rem 2.5rem 0 ;
        }

    }
}


</style>